import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { exit } from 'process';
import { ArtikelGruppen } from 'src/app/modules/webshop/store/models/artikelgruppen';
import { ArtikelGruppenService } from '../../../../artikelgruppen/shared/artikelgruppen.service';


@Component({
    selector: 'kkis-app-webshop-filter-container-category1',
    templateUrl: './filter-container-category1.component.html',
    styleUrls: ['./filter-container-category1.component.scss'],
})
export class FilterContainerCategory1Component implements OnInit, OnChanges {

    @Input()
    reihenfolgeTree: ArtikelGruppen.IArtikelGruppeListDto[];
    
    reihenfolgeTreeAll: ArtikelGruppen.IArtikelGruppeListDto[];

    @Input()
    category: string;

    // Category-Filter
    categoryFilter: ArtikelGruppen.IArtikelGruppeListDto[];

    breadcrumbList: Array<any>;

    testarray: Array<any>;

    // Images (from local <<NOT>> FROM DATABASE)
    imgDummy: string = "assets/media/svg/files/no-image.svg";

    // Utils
    isLoading: boolean = true;

    constructor(
        private router: Router,
        private artikelgruppenService: ArtikelGruppenService,
    ) { }

    ngOnInit(): void {

        this.reihenfolgeTreeAll = [];

console.log("filter-container-category1.component.ts");

        this.artikelgruppenService.getListReihenfolgeTree(true).subscribe(res => {

            this.testarray = [];
            this.testarray.length = 0;
            this.testarray.push(res);

            this.reihenfolgeTreeAll = this.testarray[0];
            this.isLoading = false;

        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        
        if (changes.category != null && changes.category.currentValue != null && changes.category.currentValue != "" && changes.category.previousValue != changes.category.currentValue) {

            let currCat = this.findCategory(changes.category.currentValue, this.reihenfolgeTreeAll);

            if (currCat) {
                this.onSelectCategory(currCat);

                this.breadcrumbList = [];

                this.breadcrumbList.length = 0;
                    
                // get category-tree for breadcrumbList
                let c = currCat.reihenfolgeWeb.split(/[/.]/);
    
                let cat: ArtikelGruppen.IArtikelGruppeListDto;
    
                let r: string;
                let isFirst = true;
                    
                c.forEach(x => {
                    if (isFirst) {
                        cat = this.findCategory(x, this.reihenfolgeTreeAll);
                        if (cat) {
                            this.createBreadcrumbList(cat);
                            isFirst = false;
    
                            r = cat.reihenfolgeWeb;
                        } else {
                            return;
                        }
                    } else {
                        r = r + "." + x;
                        cat = this.findCategory(r, this.reihenfolgeTreeAll);
                        if (cat) {
                            this.createBreadcrumbList(cat);
                        } else {
                            return;
                        }
                    }
                });
    
                if (currCat.hasChildren) {
                    this.categoryFilter = currCat.children;
                } else {
                    this.categoryFilter = null;
                }
            }

            this.isLoading = false;
        } else {
            this.breadcrumbList = null;
            this.categoryFilter = null;

            this.isLoading = false;
        }

    }

    createBreadcrumbList(category: ArtikelGruppen.IArtikelGruppeListDto) {
        this.breadcrumbList.push(category);
    }

    onSelectCategory(event) {
        if (event) {
            console.log('--> route to articles');
            this.router.navigate(['/articles'], {
                queryParams: {
                    category: event.reihenfolgeWeb,
                }
            });
            
            if (event.hasChildren) {
                this.categoryFilter = event.children;
            }
        }
    }

    private findCategory(lastLevel: string, treeList: ArtikelGruppen.IArtikelGruppeListDto[]) : ArtikelGruppen.IArtikelGruppeListDto {

        if (treeList) {
            return treeList.reduce((a, item) => {
                if (a) return a;
                if (item.reihenfolgeWeb === lastLevel) {
                    return item;
                }
                if (item.children) return this.findCategory(lastLevel, item.children);
            }, null);
        }
    }
}
